export class ImagePaths {
    static Logo = require("../Assets/Logo/logo.png");
    static LabReportOff = require("../Assets/Images/Report-Default.svg")
    static LabReportOn = require("../Assets/Images/Report.svg")
    static LabSettingOff = require("../Assets/Images/Settings-Default.svg")
    static LabSettingOn = require("../Assets/Images/Settings.svg")
    static Speciman = require("./../Assets/Icons/speciman.svg")
    static Result = require("../Assets/Icons/Results.svg")
    static Default = require("../Assets/Icons/Patient_Default.png")
    static Delete = require("../Assets/Icons/DeleteIcon.svg")
    static Edit = require("../Assets/Icons/EditIcon.svg")
    static LabCloseButton = require("../Assets/Icons/close.png")
    static LabUploadButton = require("../Assets/Icons/UploadButton.png")
    static LabPrintIcon = require('../Assets/Icons/PrintButton.svg')
    static LabEditButton = require('../Assets/Icons/EditButton.png')
    static LabViewButton = require('../Assets/Icons/ViewButton.png')
    static Close = require("../Assets/Icons/close.svg")
    static Check = require("../Assets/Icons/check.svg")
    static userConfig = require("../Assets/Icons/UserConfig.svg")
    static demographicConfig = require("../Assets/Icons/Demographics.svg")
    static Male = require("../Assets/Icons/Male.svg")
    static Female = require("../Assets/Icons/Female.svg")
    static DragIndicator = require("../Assets/Images/drag_indicator.svg")
    static Filter = require('../Assets/Icons/FilterIcon.svg')
    static Export = require('../Assets/Icons/ExportTheme.svg')
    static CardIcon = require('../Assets/Icons/CardIcon.svg')
    static CashIcon = require('../Assets/Icons/CashIcon.svg')
    static BankTransferIcon = require('../Assets/Icons/BankTransferIcon.svg')
    static UPIIcon = require('../Assets/Icons/UPIIcon.svg')
    static ChequeIcon = require('../Assets/Icons/ChequeIcon.svg')
    static DisabledEdit = require('../Assets/Icons/DisabledEdit.svg')
    static DisabledDelete = require('../Assets/Icons/DisabledDelete.svg')
    static UserEditOn = require("../Assets/Icons/User_Edit.svg")
    static UserEditOff = require("../Assets/Icons/User_Edit_off.svg")
    static ImagePreview = require("../Assets/Icons/ImagePreview.svg")
    static DocumentPreview = require("../Assets/Icons/DocumentPreview.svg")
    static SuccessAnimationGif = require("../Assets/Animation/Success.gif")
    static Mic = require("../Assets/Images/mic.svg")
    static Check = require("../Assets/Images/check.svg")
    static reply = require("../Assets/Images/replay.svg")
    static ChangeCredit = require("../Assets/Icons/ChangeCredit.svg")
    static outlinedEditDis = require("../Assets/Icons/outlinedEditDis.svg")
    static DisableUpload = require("../Assets/Icons/DisableUpload.svg")
    static InfoFill = require("../Assets/Icons/infoFill.svg")
    static LabTransfer = require('../Assets/Icons/LabTransfer.svg')
    static LabReceived = require('../Assets/Icons/LabReceived.svg')
    static LabSpecimen = require('../Assets/Icons/LabSpecimen.svg')
    static LabTransferred = require('../Assets/Icons/LabTransferred.svg')
    static GreenTick = require('../Assets/Icons/GreenTick.svg')
    static LabUpload = require('../Assets/Icons/LabUpload.svg')
    static LabTransferDbsl = require('../Assets/Icons/LabTransferDbsl.svg')
    static LabReceiveDbsl = require('../Assets/Icons/LabReceiveDbsl.svg')
    static LabReceive = require('../Assets/Icons/LabReceive.svg')
    static captureImg = require('../Assets/Icons/captureImg.svg')
    static Settlementon = require('../Assets/Icons/SettlementOn.svg')
    static Settlementoff = require('../Assets/Icons/SettlementOff.svg')
    static HistoBillingFill = require("../Assets/Icons/HistoBillingFill.svg")
    static HistoBilling = require("../Assets/Icons/HistoBilling.svg")
    static HistoSpecimanFill = require("../Assets/Icons/HistoSpecimanFill.svg")
    static HistoSpeciman = require("../Assets/Icons/HistoSpeciman.svg")
    static HistoReportingFill = require("../Assets/Icons/HistoReportingFill.svg")
    static HistoReporting = require("../Assets/Icons/HistoReporting.svg")
    static Histopathology = require("../Assets/Icons/Histopathology.svg")
}

export default ImagePaths;